<template>
<div class="chapter">
<div class="inner_page">
<div class="reviewPage" id="rew"><a id="page01"><h2 class="reviewPageHead"><span class="bold"><span>The body count keeps rising…</span></span></h2>
<p class="reviewPageText"><span>The Charmed Killer is on the loose in Atlanta and Carlotta Wren is caught up in the terror—especially when her body-moving side business brings her dangerously close to the action.</span></p>
<p class="reviewPageText"><span><em class="italic">And then…</em></span></p>
<p class="reviewPageText"><span>She’s forced to take refuge in her former fiancé’s house—much to the chagrin of other interested parties…</span></p>
<p class="reviewPageText"><span>Her brother Wesley begins to behave as if he has his own death wish…</span></p>
<p class="reviewPageText"><span>And someone close to her is implicated in the mass murders.</span></p>
<p class="reviewPageText"><span>Meanwhile, Carlotta can’t shake the feeling that danger is dogging her seemingly cursed family—and that the serial killer’s exploits are starting to get personal….</span></p>
<p class="reviewPageText"><span><span class="bold">Look for all six books in Stephanie Bond’s Body Movers series, available now from Harlequin MIRA!</span></span></p>
</a></div><a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5bodiestodiefor_rev01.vue?ddaaa8e4